import axios from 'axios'
import { addImages } from '../BFF_files/addImages'
import { REACT_APP_API } from '../../config'

export default async function updateAccount(idAccount, account) {
    try {
        if (account.images) {
            // subir las imagenes que estan en base64 a files
            // las que ya estan en files(cuando editas por ej) no se suben
            account.images = await addImages(account.images)
        }

        return await axios.put(
            `${REACT_APP_API}/integrations/account/${idAccount}`,
            account,
            {
                timeout: 300000 // 5 minutos
            }
        )
    } catch (error) {
        // Si vuelve un error con mensaje mensaje del backend, se usa ese mensaje
        if (error?.response?.data?.message)
            error.message = error.response.data.message
        throw error
    }
}
